<template>
  <div class="feature-section">
    <vue-agile
      v-if="posts.length > 1"
      ref="slider"
      autoplay
      :autoplay-speed="10000"
      :mobile-first="false"
      :nav-buttons="false"
      :dots="false"
      :responsive="[{
        breakpoint,
        settings: {
          unagile: true,
        }
      }]"
      class="feature-section__carousel"
      @after-change="makeInactiveSlidesInert($refs.slider), setActiveSlideTestId($refs.slider)"
    >
      <div
        v-for="post in posts"
        :key="post.id"
        class="feature-section__post-wrapper"
        :style="`background: ${huBackground(post)}`"
      >
        <content-renderer v-if="post" :sections="postToContentSection(post)" />
      </div>
    </vue-agile>
    <div v-else>
      <div
        v-for="post in posts"
        :key="post.id"
        class="feature-section__post-wrapper"
        :style="`background: ${huBackground(post)}`"
      >
        <content-renderer :sections="postToContentSection(post)" class="content--nested" />
      </div>
    </div>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile';
import slidesInertMixin from '@/mixins/slides-inert-mixin';
import slidesTestIdMixin from '@/mixins/slides-test-id-mixin';

export default {
  name: 'FeatureSection',
  components: {
    VueAgile,
  },
  mixins: [slidesInertMixin, slidesTestIdMixin],
  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    breakpoint: 899,
  }),
  mounted() {
    this.makeInactiveSlidesInert(this.$refs.slider);
    this.makeAllCloneSlidesInert(this.$refs.slider);
  },
  methods: {
    postToContentSection(post) {
      if (Array.isArray(post)) { return post; }
      return [post];
    },
    huBackground(post) {
      if (!post.featuredMedia || !post.featuredMedia.length) {
        return '';
      }
      return post.featuredMedia[0].huBackground;
    },
  },
};
</script>

<style lang="scss"> // no scoped - for nested vue-agile slider classes
  @import '@/stylesheets/components/_feature-section';
</style>

<docs>

This component is used in the ContentRenderer to build out a feature
sections, which is a section that displays one or more post teasers with
either text on the right or left, and an image on the right or left.

</docs>
